import { Component, Input, OnInit } from '@angular/core';
import { SiteService } from '../../service/site.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '@shared/confirm-modal/confirm-modal.component';
import { AddSycleSetupComponent } from './add-sycle-setup/add-sycle-setup.component';
import { AddBluePrintSetupComponent } from './add-blue-print-setup/add-blue-print-setup.component';
import { HttpService } from '@services/http.service';
import { ColumnDataTypes, ColumnHeader, PageHasTable } from '@shared/interfaces/tables';
import { hasPermission } from '@shared/policies/permissions';

@Component({
  selector: 'app-sycle-setup',
  templateUrl: './sycle-setup.component.html',
  styleUrls: ['./sycle-setup.component.css'],
})
export class SycleSetupComponent implements OnInit, PageHasTable {
  columnDataTypes ?: ColumnDataTypes;
  columnHeaders: ColumnHeader[];
  columnHeadersBluePrint: ColumnHeader[];
  hasPermissions = hasPermission;
  sycleSetupData;
  bluePrintSetupData;
  siteId;
  userInfo = JSON.parse(localStorage.getItem('userInfo'));
  @Input() type = 1;
  adSources;
  adSource = '';
  iFrameScript = '';

  constructor(private siteService:SiteService,
              private toastrService:ToastrService,
              private activatedRoute: ActivatedRoute,
              public modalService: NgbModal,
              public httpService:HttpService) {
    this.activatedRoute.params.subscribe(params => {
      if (params.siteId) {
        this.siteId = params.siteId;
        }
      });
    }

  ngOnInit() {
    this.getSycleSetup(this.siteId);

    this.getBluePrintSetup(this.siteId);

    this.getAdSource();

    this.getTableData();
  }

  toggleVisibility(sycle: any): void {
  const updatedValue = !sycle.onlineScheduling; 

  const payload = {
    clinicId: sycle.clinicId,
    siteId: this.siteId,
    isVisible: updatedValue
  };

  this.siteService.setSchedulerVisibility(payload).subscribe(
    (res: any) => {
      if (res?.success) {
        sycle.onlineScheduling = updatedValue;  
        this.toastrService.success(`Clinic visibility ${updatedValue ? 'enabled' : 'disabled'}.`);
      } else {
        this.toastrService.error('Failed to update visibility.');
      }
    },
    err => {
      this.toastrService.error('Server error while updating visibility.');
    }
  );
}




  getSycleSetup(siteId){
    this.siteService.getSycleSetup(siteId).subscribe(res=>{
      if(res){
        this.sycleSetupData=res;
      }
    },err=>{
      throw err;
    })
  }

  /**
   * Gets data for the tables and sets the column headers
   */
  getTableData(): void {
    this.columnDataTypes = {
    onlineScheduling: "checkmarkOrCross"
  };
    this.columnHeaders = [
      { field: 'clinicId', header: 'Clinic ID' },
      { field: 'versionName', header: 'Version' },
      { field: 'parentId', header: 'Parent ID' },
      { field: 'location', header: 'Location' },
      { field: 'callbackEmail', header: 'Callback Email' },
      { field: 'timeZoneName', header: 'TimeZone' },
      { field: 'profileName', header: 'ReviewGen Profile' },
      { field: 'onlineScheduling', header: 'Online Scheduling', width: 10 }  

    ];

    this.columnHeadersBluePrint = [
      { field: 'clinicId', header: 'Clinic ID' },
      { field: 'clinicName', header: 'Clinic Name' },
      { field: 'locationId', header: 'Location ID' },
      { field: 'reviewgenProfileName', header: 'ReviewGen Profile' } 
    ];
  }

  deleteSycle(id){
    var model = this.modalService.open(ConfirmModalComponent, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    model.componentInstance.message = 'Are you sure to delete?';
    model.result.then((result) => {
      if(result){
      this.siteService.deleteSycleSetup(id).subscribe(res=>{
        if(res){
          this.toastrService.success('Delete successfully', 'success');
          this.getSycleSetup(this.siteId);
        }
      },err=>{
        this.toastrService.error(err, 'Error');
      })
    }
    }, (reason) => {
      
    });
  }
  openSycleAddPopup(sycle?){
    var model = this.modalService.open(AddSycleSetupComponent, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    model.componentInstance.siteId = this.siteId;
    model.componentInstance.sycleSetupData = sycle;
    model.componentInstance.msg= sycle ? 'Updatd Successfully' : 'Added Successfully';
    model.result.then((result) => {
      setTimeout(() => {
        this.getSycleSetup(this.siteId);
      }, 50);
      
    }, (reason) => {
      
    });
  }
  getBluePrintSetup(siteId){
    this.siteService.getBluePrintSetup(siteId).subscribe(res=>{
      if(res){
        this.bluePrintSetupData=res;
      }
    },err=>{
      throw err;
    });
  }
  deleteBluePrint(id){
    var modal=this.modalService.open(ConfirmModalComponent,{ariaLabelledBy:'modal-basic-title',backdrop:'static'});
    modal.componentInstance.message="Are you sure to delete?";
    modal.result.then((result)=>{
      if(result){
        this.siteService.deleteBluePrintSetup(id).subscribe(res=>{
          if(res){
            this.toastrService.success('Delete successfully', 'success');
            this.getBluePrintSetup(this.siteId);
          }
        },err=>{
          this.toastrService.error(err, 'Error');
        })
      }
      }, (reason) => {
        
      });
  }
  openBluePrintAddPopup(bluePrint?){
    var model = this.modalService.open(AddBluePrintSetupComponent, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    model.componentInstance.siteId = this.siteId;
    model.componentInstance.bluePrintSetupData = bluePrint;
    model.componentInstance.msg= bluePrint ? 'Updatd Successfully' : 'Added Successfully';
    model.result.then((result) => {
      setTimeout(() => {
        this.getBluePrintSetup(this.siteId);
      }, 50);
      
    }, (reason) => {
      
    });
  }
  getAdSource(){
    this.siteService.getGeneralMaster(11).subscribe(res=>{
      if(res){
        this.adSources=res;
      }
    },err=>{
      throw err;
    })
  }
  generateIframeScript(){
    if(!this.adSource){
      this.iFrameScript='';
      return;
    }

    let data={siteId:this.siteId,adSource:this.adSource};
    this.siteService.generateIframeScript(data).subscribe(res=>{
      if(res){
        this.iFrameScript=res.IframeScript;
      }
    },err=>{
      this.httpService.openErrorPopup(err.error.message);
    })
  }
  showCopyPopup = false;

  copyToClipboard(textarea: HTMLTextAreaElement) {
    const tempTextarea = document.createElement("textarea");
    tempTextarea.style.position = "absolute";
    tempTextarea.style.left = "-9999px"; 
    tempTextarea.style.opacity = "0";
    tempTextarea.value = textarea.value; 
  
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    document.execCommand("copy"); 
    document.body.removeChild(tempTextarea); 
  
    this.showCopyPopup = true;
    setTimeout(() => {
      this.showCopyPopup = false;
    }, 2000);
  }
  

  

  setPMSType(pmsType: number): void {
    this.type = pmsType;
  }
}
